import { useContext, useEffect } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Button from "components/ui/controls/button/button";
import { FaCalculator, FaSync, FaChartLine, FaUsers, FaQuestionCircle } from "react-icons/fa";
import { CalculPartFiscale } from "components/app/Api/Remuneration/ApiRemuneration";
import ImageIR from "./Image IR.png";
import "../../../AuditComplet/ContexteFiscal/ContexteFiscal.css";
import { createStyledButton } from "components/ui/controls/button/button-styles";
import { CustomTooltip } from "components/ui/controls/custom-tooltip/custom-tooltip";

function StrategiePERContexteFiscal(props) {
  const context = useContext(AppContext);

  useEffect(() => {
    if (context.state.SetPartFiscale === false) {
      CalculPartFiscale(context.state).then((PartFiscale) => {
        context.handleValueChange("PartFiscale", PartFiscale);
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state.SetPartFiscale]);

  useEffect(() => {
    if (context.state.StrategiePERSetPartFiscaleRetraite === false) {
      if (context.state.StatutMarital === "marie" || context.state.StatutMarital === "pacse") {
        context.handleValueChange("StrategiePERPartFiscaleRetraite", 2);
      } else {
        context.handleValueChange("StrategiePERPartFiscaleRetraite", 1);
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state.StrategiePERSetPartFiscaleRetraite]);

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <CardBoxHeader icon={<FaChartLine />}>Impôt en activité</CardBoxHeader>
            <Row>
              <Column>
                <TextField
                  label="Parts fiscales"
                  labelIcon={<FaUsers />}
                  value={context.state.PartFiscale}
                  onChange={(e) => {
                    context.handleValueChange("SetPartFiscale", true);
                    context.handleValueChange("PartFiscale", Math.max(1, e.target.value));
                  }}
                  dataType="ufloat"
                  format={{ thousands: " ", precision: 2, decimal: "," }}
                  normal
                />
              </Column>
              <Column style={{ paddingTop: "34px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Button
                  tabIndex="-1"
                  icon
                  onClick={() => context.handleValueChange("SetPartFiscale", false)}
                  {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                >
                  {context.state.SetPartFiscale === false ? <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} /> : <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />}
                </Button>
              </Column>
            </Row>
            <Row>
              <Column>
                <TextField
                  label="Revenus nets imposables du foyer"
                  value={context.state.StrategiePERRevenuNetActivite}
                  onChange={context.handleInputChange("StrategiePERRevenuNetActivite")}
                  normal
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                />
              </Column>
              <Column style={{ paddingTop: "35px" }}>
                <CustomTooltip
                  tooltipStyle={{ minWidth: "700px", textAlign: "justify", padding: "14px" }}
                  type="info"
                  content={
                    <>
                      ✨ Les revenus nets imposables du foyer permettent de calculer un impôt sur le revenu et de déterminer l'économie d'impôt réalisée grâce à l'investissement sur un PER.
                      Par défaut, le montant indiqué dans la case correspond à la rémunération imposable du client après abattement forfaitaire de 10%. Si le foyer perçoit d'autres revenus,
                      vous pouvez modifier le montant. L'exemple ci dessous pour permet de savoir quel montant reporter dans la case. <br />
                      <img style={{ height: "340px", paddingTop: "25px", borderRadius: "4px" }} src={ImageIR} alt="..." />
                    </>
                  }
                >
                  <Button
                    icon
                    {...createStyledButton("card-action", "cardEdit", {
                      backgroundColor: "#dbeafe",
                      padding: "6px",
                      minWidth: "28px",
                      width: "44px",
                      height: "28px",
                    })}
                  >
                    <FaQuestionCircle style={{ color: "#3b82f6", fontSize: "14px" }} />
                  </Button>
                </CustomTooltip>
              </Column>
            </Row>
            <CardBoxHeader icon={<FaCalculator />}>Impôt à la retraite</CardBoxHeader>
            <Row>
              <Column>
                <TextField
                  label="Parts fiscales"
                  labelIcon={<FaUsers />}
                  value={context.state.StrategiePERPartFiscaleRetraite}
                  onChange={(e) => {
                    context.handleValueChange("StrategiePERSetPartFiscaleRetraite", true);
                    context.handleValueChange("StrategiePERPartFiscaleRetraite", Math.max(1, e.target.value));
                  }}
                  dataType="ufloat"
                  format={{ thousands: " ", precision: 2, decimal: "," }}
                  normal
                />
              </Column>
              <Column style={{ paddingTop: "34px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Button
                  tabIndex="-1"
                  icon
                  onClick={() => context.handleValueChange("StrategiePERSetPartFiscaleRetraite", false)}
                  {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                >
                  {context.state.StrategiePERSetPartFiscaleRetraite === false ? (
                    <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                  ) : (
                    <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                  )}
                </Button>
              </Column>
            </Row>
            <Row>
              <Column>
                <TextField
                  label="Revenus nets imposables du foyer"
                  value={context.state.StrategiePERRevenuNetRetraite}
                  onChange={context.handleInputChange("StrategiePERRevenuNetRetraite")}
                  normal
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                />
              </Column>
              <Column style={{ paddingTop: "35px" }}>
                <CustomTooltip
                  tooltipStyle={{ textAlign: "justify", padding: "14px" }}
                  type="info"
                  content={
                    <>
                      ✨ Les revenus nets imposables du foyer à la retraite permettent de calculer un impôt sur le revenu et de déterminer l'impact fiscal de la sortie du PER. Par défaut, le
                      montant indiqué dans la case correspond à la retraite imposable du client après abattement forfaitaire de 10%. Si le foyer perçoit d'autres revenus, vous pouvez
                      modifier le montant.
                    </>
                  }
                >
                  <Button
                    icon
                    {...createStyledButton("card-action", "cardEdit", {
                      backgroundColor: "#dbeafe",
                      padding: "6px",
                      minWidth: "28px",
                      width: "44px",
                      height: "28px",
                    })}
                  >
                    <FaQuestionCircle style={{ color: "#3b82f6", fontSize: "14px" }} />
                  </Button>
                </CustomTooltip>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>
    </>
  );
}

export default StrategiePERContexteFiscal;
